export default {
  WhatsAppSessionVoiceStatus: {
    pending: 'Esse contato tem uma janela de chamada pendente de resposta.',
    open: 'Esse contato tem uma janela de chamada aberta.',
  },
};
